import { ID } from './StandartId';

export const LABEL = {
  USERNAME: ID.LABEL + "username",
  PASSWORD: ID.LABEL + "password",
  REMEMBER: ID.LABEL + "remember",
};
